function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h40v40H0z"
});

var _ref2 = /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "6");

var _ref3 = /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "min");

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h40v40H0z"
});

var _ref5 = /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "14");

var _ref6 = /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "bouff\xE9es");

function SvgIcn6Min14PuffFr({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 80,
    viewBox: "0 0 40 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _ref, /*#__PURE__*/React.createElement("text", {
    "data-name": 6,
    transform: "translate(14.72 22.08)",
    style: {
      fontSize: 16,
      fill: "#5e5e5d",
      fontFamily: "Inter",
      fontWeight: 700
    }
  }, _ref2), /*#__PURE__*/React.createElement("text", {
    transform: "translate(13 35.95)",
    style: {
      fontSize: 8,
      fill: "#5e5e5d",
      fontFamily: "Inter",
      fontWeight: 700
    }
  }, _ref3)), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 40)"
  }, _ref4, /*#__PURE__*/React.createElement("text", {
    transform: "translate(10.66 22.08)",
    style: {
      fontSize: 16,
      fill: "#5e5e5d",
      fontFamily: "Inter",
      fontWeight: 700
    }
  }, _ref5), /*#__PURE__*/React.createElement("text", {
    transform: "translate(21 35.95)",
    style: {
      fontSize: 8,
      fill: "#5e5e5d",
      fontFamily: "Inter",
      fontWeight: 700,
      textAnchor: "middle"
    }
  }, _ref6)));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcn6Min14PuffFr);
export default __webpack_public_path__ + "static/media/icn-6min-14puff-fr.04729010b2f454b92d83e67032864a51.svg";
export { ForwardRef as ReactComponent };